"use client"

/**
 * Time Period Toggle Component
 * Dropdown toggle for switching between monthly, quarterly, and yearly views
 */

import { GanttChart } from "lucide-react"
import type { TimePeriod } from '@/lib/utils/dashboard-utils'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { Button } from "@/components/ui/button"

const options: { label: string; short: string; value: TimePeriod }[] = [
  { label: "Monthly", short: "M", value: "monthly" },
  { label: "Quarterly", short: "Q", value: "quarterly" },
  { label: "Yearly", short: "Y", value: "yearly" },
]

interface TimePeriodToggleProps {
  value: TimePeriod
  onChange: (value: TimePeriod) => void
}

export const TimePeriodToggle = ({ value, onChange }: TimePeriodToggleProps) => {
  const isFiltered = value !== "monthly"

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className={`h-6 w-6 ${isFiltered ? "text-primary bg-primary/10 hover:bg-primary/20" : "text-muted-foreground hover:text-foreground"}`}
        >
          <GanttChart className="h-3.5 w-3.5" />
          <span className="sr-only">Time granularity</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[100px]">
        {options.map((option) => (
          <DropdownMenuItem
            key={option.value}
            onClick={() => onChange(option.value)}
            className={`text-xs ${value === option.value ? "font-semibold bg-muted" : ""}`}
          >
            {option.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

